import { red, pink, orange } from '@material-ui/core/colors';
import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  box: {
    width: '100%',
  },
  topText: {
    color: 'rgb(0 0 0 / 54%)',
    paddingBottom: '16px',
    fontWeight: 500,
    fontSize: 14,
  },
  boxTitle: {
    fontSize: 20,
    fontWeight: 500,
    marginBottom: theme.spacing(3),
  },
  pageDesc: {
    padding: 10,
  },
  tableCheck: {
    padding: '0 !important',
  },
  paper: {
    backgroundColor: '#ffffff',
    padding: theme.spacing(3),
    boxShadow: theme.shadows[0],
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  textBox: {
    marginBottom: theme.spacing(3),
    fontSize: 14,
    maxWidth: 580,
    color: 'rgb(0 0 0 / 54%)',
  },
  rowWide: {
    position: 'relative',
    marginBottom: theme.spacing(3),
  },
  row: {
    position: 'relative',
    alignItems: 'center',
  },
  title: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '20%',
    margin: theme.spacing(0, 3.5, 0, 0),
    fontSize: 14,
    letterSpacing: 0.15,
    color: 'rgb(0 0 0 / 54%)',
  },
  desc: {
    display: 'flex',
    justifyContent: 'flex-start',
    width: '40%',
    marginLeft: theme.spacing(1),
    padding: theme.spacing(1.7),
    fontSize: 12,
    letterSpacing: 0.15,
    color: 'rgb(0 0 0 / 54%)',
  },
  input: {
    width: '100%',
    color: 'rgb(0 0 0 / 87%)',
  },
  btn: {
    padding: theme.spacing(1, 2),
    fontSize: 14,

    textTransform: 'none',
    color: 'white',
  },
  border: {
    border: '1px solid #E0E0E0',
    textAlign: 'initial',
  },
  width50: {
    width: '25%',
    textTransform: 'uppercase',
  },
  copyText: {
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'end',
    padding: '4px 12px',
    '& .MuiSvgIcon-root': {
      width: '15px',
      height: '15px',
      color: '#5081FF',
    },
  },
  rowHeightclass: {
    backgroundColor: 'red',
    height: '100px',
  },
  copied: {
    color: '#5081FF',
    height: '20px',
    width: '30px',
  },
  copiedIcon: {
    cursor: 'pointer',
    color: '#5081FF',
    height: '16px',
  },
  subHeading: {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    color: 'rgba(0, 0, 0, 0.87)',
  },
  tablemain: {
    marginTop: '25px',
  },
  cellTitle: {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    color: 'rgba(0, 0, 0, 0.87)',
  },
  imgBox: {
    width: 136,
    padding: 0,
  },
  fieldsBox: {
    width: 'calc(100% - 140px)',
    paddingLeft: theme.spacing(4),
    paddingRight: 0,
  },
  tooltipStyle: {
    width: '55%',
  },
  modelKey: {
    height: '32px',
  },
  link: {
    color: '#5081FF',
  },
  keyData: {
    marginTop: 20,
    '& h1': {
      fontSize: '20px',
      fontWeight: 600,
      marginTop: 10,
    },
  },
  btnBox: {
    paddingBottom: '14px',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  btnWide: {
    padding: theme.spacing(1, 5),
    fontSize: 14,
    textTransform: 'none',
  },
  btnWideRight: {
    background: '#007DFF',
    color: 'white',
    padding: theme.spacing(1, 5),
    fontSize: 14,
    textTransform: 'none',
    marginLeft: 10,
  },
  btnWideLeft: {
    background: '#5081FF',
    color: 'white',
    padding: theme.spacing(1, 2),
    fontSize: 14,
    textTransform: 'none',
  },
  deleteBtn: {
    display: 'flex',
    borderBottom: 'none',
    alignItems: 'center',
    justifyContent: 'center',
  },
  tableBox: {
    width: '100%',
    padding: 0,
  },
  btnbox: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  noBorder: {
    border: 'none',
  },
  dropdown: {
    position: 'absolute',
    zIndex: 1,
    right: '22px',
    width: 270,
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    boxShadow: '0px 6px 6px rgba(0, 0, 0, 0.26), 0px 10px 20px rgba(0, 0, 0, 0.19)',
    borderRadius: 4,
  },
  selectItem: {
    padding: theme.spacing(1, 1.2),
    '& svg': {
      marginRight: theme.spacing(1.2),
    },
    '& img': {
      marginRight: theme.spacing(1.2),
    },
  },
  generateSteps: {
    display: 'grid',
    gap: theme.spacing(1.4),
    color: 'rgba(0, 0, 0, 0.78)',
    fontSize: 14,
    '& strong': {
      fontWeight: 600,
    },
  },
  generateStepFields: {
    marginLeft: theme.spacing(3),
    padding: theme.spacing(1.5),
    border: '1px solid #E0E0E0',
    borderRadius: 4,
    backgroundColor: '#F8FAFC',
    display: 'grid',
    gap: theme.spacing(0.75),
  },
  btnAdd: {
    textTransform: 'capitalize',
    boxShadow: theme.shadows[0],
    padding: theme.spacing(0, 1),
    marginLeft: theme.spacing(2),
    minWidth: 64,
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    borderRadius: 4,
    '&:hover': {
      backgroundColor: 'rgb(0, 87, 178)',
      boxShadow:
        '0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)',
    },
    '& svg': {
      fill: '#ffffff',
    },
  },
  dataGrid: {
    width: '100%',
    height: 'auto',
    '& .MuiDataGrid-root .MuiDataGrid-row.Mui-selected ': {},
    '& .MuiDataGrid-root .MuiDataGrid-row': {
      '&:hover': {
        backgroundColor: 'rgba(255, 80, 95, 0.04)',
      },
    },
    '& .row-background-error': {
      backgroundColor: red[50],
      '&:hover': {
        backgroundColor: red[100],
      },
    },
    '& .row-background-alert': {
      backgroundColor: pink[50],
      '&:hover': {
        backgroundColor: pink[100],
      },
    },
    '& .row-background-transaction': {
      backgroundColor: 'white',
      '&:hover': {
        backgroundColor: 'rgba(255, 80, 95, 0.04)',
      },
    },
    '& .cell-text-color-error': {
      color: pink[700],
    },
    '& .cell-text-color-alert': {
      color: orange[700],
    },
    '& .cell-text-color-transaction': {
      color: 'black',
      fontWeight: '500',
      textTransform: 'capitalize',
    },
    '& .MuiDataGrid-colCellTitle': {
      color: 'black',
      fontWeight: 'bold',
      textTransform: 'capitalize',
    },
  },
}));
